import * as Types from 'constants/Types';


const initialState = {
    isLoading: false,
    isReloadData: false,
    isSubmit: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.APP_UI_DELETE_ACTION: 
            return {...state, isLoading: true, isReloadData: false}
        case Types.APP_UI_DELETE_SUCCESS:
            return {...state, isLoading: false}
        case Types.APP_UI_DELETE_FAIL: 
            return {...state, isLoading: false}
        case Types.APP_UI_RELOAD_DATA:
            return {...state, isReloadData: true}
        case Types.APP_UI_CREATE_TRANSLATE_ACTION: 
            return {...state, isLoading: true, isReloadData: false}
        case Types.APP_UI_CREATE_TRANSLATE_SUCCESS:
            return {...state, isLoading: false};
        case Types.APP_UI_CREATE_TRANSLATE_FAIL:
            return {...state, isLoading: false}
        case Types.APP_UI_UPDATE_TRANSLATE_ACTION:
            return {...state, isLoading: true, isReloadData: false}
        case Types.APP_UI_UPDATE_TRANSLATE_FAIL:
            return {...state, isLoading: false}
        case Types.APP_UI_UPDATE_TRANSLATE_SUCCESS: 
            return {...state, isLoading: false}
        case Types.APP_UI_DELETE_TRANSLATE_ACTION: 
            return {...state, isLoading: true, isReloadData: false};
        case Types.APP_UI_DELETE_TRANSLATE_SUCCESS:
            return {...state, isLoading: false}
        case Types.APP_UI_DELETE_TRANSLATE_FAIL:
            return {...state, isLoading: false}
        default:
            return state
    }
}